import React, { Component } from 'react';
import ReactTable from "react-table-6"
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";
import { DialogComponent } from '@syncfusion/ej2-react-popups';
import 'react-widgets/dist/css/react-widgets.css';
import Loader from 'react-loader-spinner';

class Facebook extends Component {
  constructor() {
    super();

    this.dialogClose = () => {
      this.setState({ hideupdateDialog: false, hideAddDialog: false, hideErrorAddingDialog: false, hideDeletePopup: false });
    };

    this.settings = { effect: 'Zoom', duration: 400, delay: 0 };

    //for update dialog component ok click
    this.Okbutton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDataApi()
        this.dialogClose();
        this.setState({
          isChecked: true

        })
      }
    }];
    this.addedButton = [{
      buttonModel: {
        content: 'OK',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.fetchDataApi()
        this.dialogClose();
        this.setState({
          isChecked: true,
          disabled: false
        })
      }
    }];


    //for delete dialog component ok click
    this.buttons = [{
      buttonModel: {
        content: 'Yes',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.deleteFacebookApi(props, this.state.propsId)
        this.setState({
          isChecked: true,
          disabled: false, showTable: true
        })

      }
    }
      , {
      buttonModel: {
        content: 'No',
        cssClass: 'e-flat',
        isPrimary: true,
      },
      'click': () => {
        this.setState({
          hideDeletePopup: false,
          isChecked: true,
          disabled: false,
          showTable: true
        });
      }
    }];

    //for delete success
    this.deleteSuccessbuttons = [{
      buttonModel: {
        content: 'Ok',
        cssClass: 'e-flat',
        isPrimary: true,

      },
      'click': props => {
        this.dialogInstance.hide();
        this.fetchDataApi()
        this.setState({ isChecked: true, disabled: false, showTable: true })

      }
    }];


    this.state = {
      isChecked: false,
      actiavteDisable: false,
      showTable: false,
      deactivateDisable: true,
      data: [
        {
          id: '',
          socialPlatformProperty: '',
          socialPropertyValue: '',

          deleteRow: false

        }
      ],
      nameList: [],
      disabled: false,
      editedId: '-1',
      editImageSrc: './assets/images/edit2.png',
      hidden: false,
      hideAddDialog: false,
      hideupdateDialog: false,
      hideDeletePopup: false,

      hideErrorAddingDialog: false,
      activateFacebook: '-1',
      deactivateFacebook: '-1',
      deactivateFacebook: '-1',
      successResp: false,
      propertyChange: false,
      selectedProperty: []
    }
    this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
    this.editImageSrc = "./assets/images/edit2.png";
    this.activatechangedId = "-2";
    this.deActivatechangedId = "-2";
    this.activateFb = "off";
    this.socialPlatformPropertyVar = [];
    this.addedData = [];
    this.disableOption = false;
  }
  componentDidMount() {
    localStorage.setItem('socialPlatform', 'FACEBOOK')
    setTimeout(() => {
      this.fetchProjectDetailsApi();
      this.fetchNameApi();
      this.fetchDataApi();
    }, 300);

    var thisController = this;
    document.addEventListener("projectChanged", function (event) {
      thisController.projectId = event.projectId;
      localStorage.setItem('socialPlatform', 'FACEBOOK')
      thisController.fetchProjectDetailsApi(event.projectId);
      thisController.fetchNameApi();
      thisController.fetchDataApi(event.projectId);
    });


  }

  fetchProjectDetailsApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var voiceController = this;
    $.ajax({
      url: "/api/project-details",
      async: false,
      method: 'GET',
      data: {
        "projectId": projectId
      },
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {
        if (res.success === true) {
          if (res.result.deployed == false) {
            voiceController.notifyNotAdded("Oops!you have not deployed your project")
            var voiceInterval = setInterval(function () {
              clearTimeout(voiceInterval);
              window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
            }, 3000);
          }
        } else {
          voiceController.notifyNotAdded("Oops!you have not deployed your project")
          var voiceInterval = setInterval(function () {
            clearTimeout(voiceInterval);
            window.location.href = '/platform/projectmgmt/test-and-deploy/DistributionWidget';
          }, 3000);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/";
        }
      }
    });
  }


  notifyNotAdded(message) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;{message}</b>, {
      position: "top-center"
    });
  }


  saveFacebookApi = (props, e) => {
    var addController = this;


    props.original.socialPropertyValue =
      document.getElementById("socialPropertyValue" + props.index).innerText
    props.original.socialPlatformProperty =
      document.getElementById("socialPlatformProperty" + props.index).value;



    addController.state.editedId = "-1";
    addController.setState(this.state);

    var validateResult = addController.validateCells(addController.selectedValue, props.original.socialPlatformProperty,
      props.original.socialPropertyValue.trim());


    if (validateResult == true) {
      var addedData = {
        socialPlatformProperty: props.original.socialPlatformProperty,
        socialPropertyValue: props.original.socialPropertyValue,
        projectId: localStorage.getItem('currentProjectId'),
        socialPlatform: localStorage.getItem('socialPlatform')

      };


      $.ajax({
        url: "/api/social-properties",
        async: false,
        method: 'POST',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(addedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {


            addController.notifyAdd();
            addController.fetchDataApi();
            addController.state.disabled = false;


          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })

    }

  }
  notifyAdd() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />&nbsp;&nbsp;Facebook Property Added Successfully</b>, {
      position: "top-center",

    });
  }
  notifyError(response) {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />
      {response}</b>, {
      position: "top-center"
    });
  }


  updateFacebookApi(props, e) {
    var updateController = this;

    props.original.socialPropertyValue = document.getElementById("socialPropertyValue" + props.index).innerText


    props.original.socialPlatformProperty = document.getElementById("socialPlatformProperty" + props.index).value;
    if (updateController.state.propertyChange == true) {
      var validateResult = updateController.validateCells(updateController.state.selectedValue, props.original.socialPlatformProperty, props.original.socialPropertyValue);
    }
    else {
      var validateResult = updateController.validateUpdatedDate(props.original.socialPropertyValue);
    }

    if (validateResult == true) {
      var updatedData = {
        socialPlatformProperty: props.original.socialPlatformProperty,

        socialPropertyValue: props.original.socialPropertyValue,
        id: props.original.id,
        projectId: localStorage.getItem('currentProjectId'),
        socialPlatform: localStorage.getItem('socialPlatform')

      };
      var updatedDataController = this
      $.ajax({
        url: "/api/social-properties",
        async: false,
        method: 'PATCH',
        headers: {
          'Authorization': "Bearer " + localStorage.getItem("access_token"),
          'Content-Type': 'application/json',
        },
        data: JSON.stringify(updatedData),
        processData: false,
        contentType: "application/json; charset=UTF-8",
        success: function (res) {
          if (res.success === true) {
            updatedDataController.state.editedId = "-1";
            updatedDataController.notifyUpdate();
            updatedDataController.fetchDataApi();
          } else {
            updatedDataController.notifyError(res.result);
          }
        },
        error: function (xhr, status, error) {
          var errorMessage = xhr.status + ': ' + xhr.statusText
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      })
    }
  }
  notifyUpdate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
      content="" />&nbsp;&nbsp;Facebook Property Updated Successfully</b>, {
      position: "top-center",

    });
  }

  deleteFacebookApi = (props, id) => {
    let deleteRowViewController = this.state.data;
    let deleteApiViewController = this;
    var deleteConstructorVariables = this;



    $.ajax({
      url: "/api/social-properties/" + id,
      async: false,
      method: 'DELETE',
      headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
      success: function (res) {

        if (res.success === true) {

          deleteApiViewController.setState({ deleteRow: true });
          deleteConstructorVariables.setState({ hideDeletePopup: false });
          deleteApiViewController.notifyDelete();
          deleteRowViewController.splice(id, 1);



        } else {
          deleteApiViewController.notifyError(res.result);
        }
      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });
    deleteApiViewController.fetchDataApi();

  }
  notifyDelete() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg" style={{ paddingRight: '0px' }}
      content="" />&nbsp;&nbsp;Facebook Property Deleted Successfully</b>, {
      position: "top-center",

    });

  }




  fetchDataApi = (projectId) => {
    if (!projectId) {
      projectId = this.projectId;
      if (!projectId) {
        projectId = localStorage.getItem('currentProjectId');
      }
    }
    var fetchDataContoller = this;

    $.ajax({
      url: "/api/social-properties",
      async: false,
      method: 'GET',
      data: {
        projectId: projectId,
        socialPlatform: localStorage.getItem('socialPlatform'),

      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var messages = res.result;

          fetchDataContoller.setState({
            data: messages,
            disabled: false,
            successResp: true
          })
          fetchDataContoller.state.selectedValue = [];
          for (var i = 0; i < messages.length; i++) {


            fetchDataContoller.state.selectedValue.push(messages[i]["socialPlatformProperty"])

          }


        } if (messages.length == 0) {
          fetchDataContoller.setState({
            isChecked: false,
            showTable: false
          })


        }

        else if (messages[0]["id"] != "" ||
          messages[0]["id"] != null) {

          fetchDataContoller.setState({
            isChecked: true,
            showTable: true
          })
        }
        else {
          fetchDataContoller.setState({
            successResp: false
          })
          fetchDataContoller.notifyError(res.result);

        }



      },
      error: function (xhr) {
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });

  }


  fetchNameApi = () => {
    var socialPlatformPropertyController = this;
    $.ajax(
      {
        url: "/api/social-properties-names",
        async: false,
        method: 'GET',
        data: {
          socialPlatform: localStorage.getItem('socialPlatform')
        },

        headers: { 'Authorization': "Bearer " + localStorage.getItem("access_token") },
        success: function (res) {
          if (res.success === true) {
            var socialPlatformPropertys = res.result;
            socialPlatformPropertyController.state.data.socialPlatformProperty = socialPlatformPropertys
            var numberOfsocialPlatformPropertys = socialPlatformPropertys.length;
            var ele3 = document.getElementById("socialPlatformProperty");
            socialPlatformPropertyController.socialPlatformPropertyVar = [];


            for (var i = 0; i < numberOfsocialPlatformPropertys; i++) {

              socialPlatformPropertyController.socialPlatformPropertyVar[i] = (socialPlatformPropertys[i]['key']);

            }

          }
          else {
            socialPlatformPropertyController.notifyError(res.result);
          }
        },
        error: function (xhr) {
          if (xhr.status == 401) {
            window.location.href = "/platform/";
          }
        }
      }
    )
  }
  activateFacebookAjax = () => {
    var fetchDataContoller = this;

    $.ajax({
      url: "/api/project-socialIntegration",
      async: false,
      method: 'POST',
      data: {
        projectId: localStorage.getItem('currentProjectId'),
        socialPlatform: localStorage.getItem('socialPlatform'),

      },
      headers: {
        "Authorization": "Bearer " + localStorage.getItem("access_token"),
      },

      success: function (res) {
        if (res.success === true) {
          var messages = res.result;
          fetchDataContoller.setState({
            isChecked: true, showTable: true
          })



        } else {
          fetchDataContoller.notifyFailedActivate();

        }



      },
      error: function (xhr, status, error) {
        var errorMessage = xhr.status + ': ' + xhr.statusText
        if (xhr.status == 401) {
          window.location.href = "/platform/";
        }
      }
    });

  }


  notifyFailedActivate() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
      content="" />&nbsp;&nbsp;Oops! Failed to activate Facebook</b>, {
      position: "top-center"
    });
  }



  validateCells(selectedValue, socialPlatformProperty, socialPropertyValue) {



    for (var i = 0; i < this.state.selectedValue.length; i++) {
      if (this.state.selectedValue[i] == socialPlatformProperty) {
        this.notifyProperty();
        this.state.propertyChange = false;
        return false;
      }
    }


    if ((socialPlatformProperty == "" || socialPropertyValue == "" || socialPropertyValue == undefined)) {
      this.notifyMsgFieldEmpty();
      this.state.propertyChange = false;

      return false;
    }
    else {
      this.state.propertyChange = false;
      return true;
    }

  }


  validateUpdatedDate(value) {
    if (value == "" || value == null) {
      this.notifyMsgFieldEmpty();
      return false;
    }
    else {
      return true;
    }
  }
  notifyMsgFieldEmpty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
      Please mention the value</b>, {
      position: "top-center"
    });

  }
  notifyProperty() {
    toast.dismiss();
    toast(<b><img src="assets/images/warn.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
      The selected Facebook property has been already added       </b>, {
      position: "top-center"
    });

  }



  addRow = (data) => {


    this.state.data.unshift({
      socialPlatformProperty: this.state.socialPlatformProperty,
      socialPropertyValue: '',
      socialPlatformProperty: this.socialPlatformPropertyVar



    });
    this.setState({
      data: this.state.data,
      disabled: true
    })
  }

  makeCelleditable(props, e) {
    this.markAsBeingEdited(props.original.id);
  }
  markAsBeingEdited(id) {
    this.state.editedId = id;
    var stateObj = this.state;
    this.setState(stateObj);
  }
  refreshData = (id) => {
    var refreshContent = this
    refreshContent = this.state.editedId = id;
    this.fetchDataApi()
    this.setState({
      disabled: false,
      isChecked: true,
      showTable: true
    })
  }


  comboBoxHandleChange = (props, e) => {
    props.original.socialPlatformProperty = e;
    this.setState(this.state);
  }
  socialPropertyValueHandleChange(event, props) {

    props.original.socialPropertyValue = document.getElementById("socialPropertyValue" + props.index).innerText;

    this.setState(this.state);
  }

  queryHandleChange = (e) => {

    this.fetchByqueryApi();

  }

  notifyActivate() {
    toast.dismiss();
    toast(<b><img src="assets/images/done.svg"
      style={{ paddingRight: '0px', height: '20px', width: '20px' }} content="" />&nbsp;&nbsp;
      Facebook activated successfully </b>, {
      position: "top-center"
    });

  }



  checkHandle = () => {
    if (document.getElementById("activate").checked == true) {
      this.activateFacebookHandleChange();
    } else {
      this.deActivateFacebookHandleChange();
    }
  }
  activateFacebookHandleChange = (e) => {

    this.setState({

      isChecked: true,
      showTable: true

    })

    this.activateFacebookAjax();
  }

  deActivateFacebookHandleChange = (e) => {
    if (this.state.data.length > 0) {
      this.setState({
        isChecked: true,
        showTable: true
      })
    } else {
      this.setState({
        isChecked: false,
        showTable: false
      })
    }
  }

  optionHandleChange = (props, e) => {
    props.original.socialPlatformProperty = e.target.value;
    for (var i = 0; i < this.state.selectedValue.length; i++) {
      if (props.original.socialPlatformProperty == this.state.selectedValue[i]) {
      }
    }

    this.setState(this.state);
    this.state.propertyChange = true;
  }




  render() {
    const { data } = this.state
    const columns = [
      {
        Header: <b>Name</b>,
        width: 400,
        textAlign: 'screenLeft',
        accessor: 'socialPlatformProperty',
        sortable: false,
        Cell: props => {
          return (
            <div className="container-fluid" style={{ textAlign: "right" }}>
              <div className="container-fluid" style={{ textAlign: "right" }}>
                <select className="input-group form-control select2 " onChange={(e) => this.optionHandleChange(props, e)}
                  value={props.original.socialPlatformProperty} id={"socialPlatformProperty" + props.index}
                  style={{
                    background: 'white', border: 'none', border: (props.original.id == undefined ||
                      props.original.id == this.state.editedId) ? '1px solid #D2D4DC' : 'none',
                    borderRadius: (props.original.id == undefined) ? '2px' : 'none'
                  }}
                  disabled={(props.original.id == null) ? false : props.original.id != this.state.editedId}>
                  {this.socialPlatformPropertyVar.map(socialPlatformProperty => (
                    <option key={socialPlatformProperty} value={socialPlatformProperty} >
                      {socialPlatformProperty}
                    </option>
                  ))}
                </select>
              </div>

            </div>
          )
        },
      },


      {
        Header: <b>Value</b>,
        accessor: 'socialPropertyValue',
        sortable: false,
        Cell: props =>
        (<div
          Align="left" className="input"
          style={{
            padding: '8px', width: '98%', borderBottom: 'none',
            border: (props.original.id == undefined || props.original.id == this.state.editedId) ?
              '1px solid #D2D4DC' : 'none', borderRadius: (props.original.id == undefined) ? '2px' : 'none', paddingLeft: '2px'
          }}
          suppressContentEditableWarning
          contentEditable={!((props.original.id == undefined) ? false :
            props.original.id != this.state.editedId) ? "plaintext-only" : false}

          type="text" id={"socialPropertyValue" + props.index} value={props.original.id == undefined ? "" :
            props.original.socialPropertyValue} >{props.original.socialPropertyValue}</div>)
      },
      {
        Header: <b>Action</b>,
        accessor: 'action',
        width: 100,
        sortable: false,
        Cell: props => (
          <div id="action">
            {/* edit button */}
            <div style={{ marginTop: '-9px' }}>
              <p>


                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                  <img className="img-responsive"
                    title={(props.original.id == undefined) || (this.state.data[props.index].id == this.state.editedId) ? 'Save' : 'Edit'}


                    style={{ marginTop: '8px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: 'pointer' }}
                    src={(props.original.id == null) ?
                      this.saveImageSrc : ((props.original.id != this.state.editedId) ?
                        this.editImageSrc : this.saveImageSrc)}
                    onClick={(e) => {
                      (props.original.id == null) ?
                        this.saveFacebookApi(props, e) :
                        (props.original.id == this.state.editedId) ?
                          this.updateFacebookApi(props, e) :
                          this.makeCelleditable(props, e);
                    }}
                  /></button>
                <button style={{ backgroundColor: "#ffffff", border: "none" }}>
                  <img className="img-responsive" src={"./assets/images/baseline_delete_white_24dp.png"}
                    title="Delete"
                    style={{ marginTop: '6px', backgroundColor: '#282a65', borderRadius: '5px', padding: '1px', cursor: 'pointer' }}

                    onClick={() => {
                      this.setState({
                        hideDeletePopup: true, deletePropIndex: props.index,
                        propsId: props.original.id
                      })
                    }}
                  /></button>
              </p>
            </div>
          </div>
        ),
      },
    ]
    return (
      <div>
        <Loader
          type="TailSpin"
          color="#282a65"
          visible={this.state.successResp ? false : true}
          height={300}
          width={50}
          style={{ textAlign: 'center' }}
        />
        <ToastContainer className="Toast-at-center" />

        <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">


          {/* for toaster */}
          <link rel="stylesheet" href="assets/css/ReactToastify.css" />

          {/* for reactTable */}
          <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
          <link rel="stylesheet" href="assets/css/toggleButton.css" />

          {/*for dialog component */}
          <link href="assets/css/ej2-base.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-buttons.css" rel="stylesheet" />
          <link href="assets/css/ej2-react-popups.css" rel="stylesheet" />
          <link href="assets/css/ej2-inputs.css" rel="stylesheet" />
          <link href="assets/css/screenResolution.css" rel="stylesheet" />
          <div className="container-fluid">
            <div className="row" style={{ marginLeft: '2px' }}>
              <label>Activate Facebook</label>
              <label class="switch" style={{ marginLeft: '15px' }}>

                <input type="checkbox"
                  id={"activate"}
                  onChange={this.checkHandle}

                  checked={this.state.isChecked}
                />
                <span class="slider round"></span>
              </label>


            </div>
            <div className="row" id="AlexaProperties" style={{ display: this.state.isChecked ? 'block' : 'none' }}>
              <div className="col-sm-6">
                <h6 className="nav-item" style={{
                  color: '#282a65',
                  marginTop: '24px', marginLeft: '2px'
                }}>Facebook configuration</h6>
              </div>
              {/* Add button and refresh button*/}
              <div className="col-sm-6" Align='right'>
                <button className="btn action-button "
                  title="Add"
                  id="addMsg"
                  onClick={this.state.disabled ? this.notifyMsgFieldEmpty : this.addRow} >
                  <img src="assets/images/add_white_24dp.png" />
                </button>
                <button onClick={this.refreshData} className="btn action-button" title="Refresh">
                  <img src="./assets/images/refresh_white_24dp.png"></img>
                </button>
              </div>

            </div>
          </div>
          <div className="content" id="FacebookProperties"
            style={{ display: this.state.isChecked ? 'block' : 'none' }}>
            <div className="container-fluid">
              <div className="row" >
                <div className="col-lg-12 ">
                  <div className="card" >
                    <ReactTable
                      data={data}
                      columns={columns}
                      defaultPageSize={5}
                      pageSizeOptions={[5, 10, 15]}

                    />
                  </div>




                  {/*Dialog Component For Deletion Confirmation*/}
                  <DialogComponent width='400px' animationSettings={this.settings}
                    header='Facebook' showCloseIcon={true} buttons={this.buttons}
                    ref={dialog => this.dialogInstance = dialog}
                    visible={this.state.hideDeletePopup} close={this.dialogClose}>
                    <img src="./assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                      content="" />&nbsp;Do you want to delete the Facebook property?<br />Note: Press 'Yes' to delete or press 'No' to decline.


                  </DialogComponent>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    )

  }
}

export default Facebook;


// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/Facebook.js